// extracted by css-extract-rspack-plugin
export default {"UpsellCTALink":"xizXq","Medium":"mZORI","Large":"ET_Qb"};